import { canAccessExpansionFieldRoles, REPORTING_ROLE_PATTERNS } from "./commercialRoleAccess";
import { canViewerPermission, getViewerEmailFromStorage } from "./userMatrixStorage";
import { isPluginEnabled, PLUGIN_IDS } from "./registry";

export function reportingPluginEnabled() {
  return isPluginEnabled(PLUGIN_IDS.REPORTING);
}

export function canAccessReporting(viewerEmail) {
  if (!reportingPluginEnabled()) return false;
  const email = viewerEmail ?? getViewerEmailFromStorage();
  if (canViewerPermission(email, "canAccessReporting", false)) return true;
  return canAccessExpansionFieldRoles(REPORTING_ROLE_PATTERNS, email);
}
